import { useMutation } from '@apollo/client';

import { MARK_ALL_NOTIFICATIONS_READ, MARK_NOTIFICATION_READ } from '../graphql/mutations';
import type { UserError } from '../types/notifications.types';

// Refetch by operation NAME (the platform convention) so the list and the bell badge both refresh
// after a read — the read mutation returns the notification so Apollo also normalises it by id.
const REFETCH = ['Notifications', 'UnreadNotificationCount'];

/** The recipient's read interactions: mark one read, or mark all read. */
export function useNotificationMutations() {
  const [markReadMutation, { loading: marking }] = useMutation(MARK_NOTIFICATION_READ, {
    refetchQueries: REFETCH,
  });
  const [markAllMutation, { loading: markingAll }] = useMutation(MARK_ALL_NOTIFICATIONS_READ, {
    refetchQueries: REFETCH,
  });

  const markRead = async (notificationId: string): Promise<UserError[]> => {
    const { data } = await markReadMutation({ variables: { input: { notificationId } } });
    return data?.markNotificationRead.errors ?? [];
  };

  const markAllRead = async (): Promise<UserError[]> => {
    const { data } = await markAllMutation();
    return data?.markAllNotificationsRead.errors ?? [];
  };

  return { markRead, markAllRead, marking, markingAll };
}
